const distances = {
  pageMarginBig: 2,
  pageMarginSmall: 2,
  gapSmall: 1,
  gapBig: 2,
radius: 0.4,
};

export default distances;
